// extracted by mini-css-extract-plugin
module.exports = {"btnWrapper":"_1VTg2WITsGtUV5rc9DcYZh","cancelBtn":"_23mRqjPvOZmUVqRWLUGkhw","saveBtn":"_71ZO3knERmfAMBdjqMiIJ"};